import { useMenuSelectors } from "../../../../app/state/menuSlice/hook/use-menu-selectors";
import { TMenuIds } from "../../../../app/state/menuSlice/types";
import { MenuBasic } from "../../../../common/Components/Menu/MenuBasic";
import { AppMenuItem } from "../../../../shared/components/AppMenu/AppMenuItem";
import { EXPORT_SCHEMA_MENU_ACTIONS } from "../../constants";
import { TDownloadSchema, TSchemaExportExtensions } from "../../types";
import styles from "./styles.module.css";

interface Props {
  handleExport: (
    type: TSchemaExportExtensions,
    downloadType: TDownloadSchema,
  ) => void;
  closeMenu: (id: TMenuIds) => void;
}

export const ExportDrawIoSchemaMenu = ({ handleExport, closeMenu }: Props) => {
  const exportSchema = useMenuSelectors("export_drawio_schema_menu");

  return (
    <MenuBasic
      isOpen={exportSchema.isOpen}
      position={exportSchema.position}
      anchorPosition={{
        left: exportSchema.position?.x ?? 0,
        top: exportSchema.position?.y ?? 0,
      }}
      transformOrigin={{
        vertical: "top",
        horizontal: "right",
      }}
      onClose={() => {
        closeMenu("export_drawio_schema_menu");
      }}
    >
      {EXPORT_SCHEMA_MENU_ACTIONS.map((action) => (
        <AppMenuItem
          key={action.id}
          onClick={() => {
            handleExport(
              action.extension,
              (exportSchema.info?.value as TDownloadSchema) ?? "artifacts",
            );
            closeMenu("export_drawio_schema_menu");
          }}
          className={styles["menu-item"]}
        >
          {action.name}
        </AppMenuItem>
      ))}
    </MenuBasic>
  );
};
